import React from "react";
import { Check, ArrowRight } from "lucide-react";

const VIP_IMG =
  "https://customer-assets.emergentagent.com/job_derya-stock-picks/artifacts/yzfalbcz_SnapInsta.to_520934028_18511328557058180_9150144397919978163_n.jpg";

const PERKS = [
  "Günlük fırsat hisseler ve piyasa yorumları",
  "Hedef ve stop seviyeleri ile özel analizler",
  "Anlık piyasa hareketleri ve sıcak gelişmeler",
  "Takip listesi ve sektörel öneriler",
  "Soru–cevap & topluluk içi paylaşımlar",
];

export default function TelegramVIP({ telegramUrl }) {
  return (
    <section
      id="telegram-vip"
      className="relative py-24 md:py-32 overflow-hidden"
      data-testid="telegram-vip-section"
    >
      {/* Decorative blob */}
      <div className="absolute -top-32 -right-32 w-[420px] h-[420px] rounded-full bg-[#d4af37] opacity-[0.05] blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 -left-32 w-[420px] h-[420px] rounded-full bg-[#d4af37] opacity-[0.04] blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Image side */}
          <div className="lg:col-span-5">
            <div
              className="relative max-w-md mx-auto lg:mx-0"
              data-testid="vip-image-wrapper"
            >
              <div className="photo-frame aspect-[4/5] shadow-[0_40px_80px_-20px_rgba(212,175,55,0.25)]">
                <img
                  src={VIP_IMG}
                  alt="Derya Eliz Yıldız - Telegram VIP grup"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              {/* Stats overlay */}
              <div
                className="absolute -top-6 -left-6 glass-card rounded-2xl px-6 py-5"
                data-testid="vip-stat-card"
              >
                <div className="font-serif text-5xl md:text-6xl text-gold-gradient leading-none">
                  %91
                </div>
                <div className="mt-2 text-[10px] tracking-[0.28em] uppercase text-[#cbd5e1]">
                  İSABET ORANINA VARAN*
                </div>
              </div>
            </div>
          </div>

          {/* Content side */}
          <div className="lg:col-span-7">
            <span
              className="section-eyebrow"
              data-testid="vip-eyebrow"
            >
              Telegram VIP Grubu
            </span>
            <h2
              className="font-serif text-white text-[clamp(2rem,4.6vw,3.75rem)] leading-[1.08] mt-3"
              data-testid="vip-title"
            >
              Piyasayı kaçırma,
              <br />
              <span className="italic text-gold-gradient">VIP üyelere katıl.</span>
            </h2>
            <p
              className="mt-6 text-[#cbd5e1] text-base md:text-lg font-light leading-relaxed max-w-2xl"
              data-testid="vip-description"
            >
              Telegram VIP grubunda günlük fırsat hisseler, piyasa yorumları,
              özel analizler ve takip listeleri paylaşılır.
            </p>

            <ul
              className="mt-8 space-y-3"
              data-testid="vip-perks"
            >
              {PERKS.map((p, i) => (
                <li
                  key={i}
                  className="flex items-start gap-3 text-[#e2e8f0] text-[15px]"
                  data-testid={`vip-perk-${i}`}
                >
                  <span className="shrink-0 w-5 h-5 rounded-full bg-[#d4af37]/15 border border-[#d4af37]/50 flex items-center justify-center mt-0.5">
                    <Check size={12} className="text-[#d4af37]" />
                  </span>
                  <span className="font-light">{p}</span>
                </li>
              ))}
            </ul>

            <div className="mt-10 flex flex-wrap gap-3">
              <a
                href={telegramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-gold px-7 py-4 rounded-full inline-flex items-center gap-2.5 text-[15px]"
                data-testid="vip-telegram-cta"
              >
                <i className="fa-brands fa-telegram text-lg" />
                VIP Telegram Grubuna Katıl
                <ArrowRight size={18} />
              </a>
              <a
                href={telegramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-ghost px-7 py-4 rounded-full inline-flex items-center gap-2.5 text-[15px]"
                data-testid="vip-followup-cta"
              >
                Fırsat Hisseleri Takip Et
              </a>
              <a
                href={telegramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-ghost px-7 py-4 rounded-full inline-flex items-center gap-2.5 text-[15px]"
                data-testid="vip-analysis-cta"
              >
                Özel Analizlere Ulaş
              </a>
            </div>

            <p
              className="mt-6 text-[11px] text-[#64748b] tracking-wide max-w-xl"
              data-testid="vip-disclaimer-note"
            >
              *Geçmiş paylaşımlara dayalıdır. Geçmiş performans gelecekteki
              sonuçları garanti etmez ve yatırım tavsiyesi niteliği taşımaz.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
